import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import IResponse = ZoneIQCalibration.IResponse;
import IOverlay = ZoneIQCalibration.IOverlay;
import { environment } from '../../../environments/environment';

const API = environment.ZONEIQ_CALIBRATION + '/v1/overlay';

@Injectable({
    providedIn: 'root'
})
export class OverlayService {
    constructor(private readonly http: HttpClient) {}

    updateOverlay(overlay: IOverlay) {
        if (!overlay) {
            return;
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const params = new HttpParams().set('syncChanges', 'true');

        return this.http.post<IResponse>(API, overlay, { headers, params });
    }
}
